<template>
  <div id="app">
    <!-- 缓存区：只缓存 keepAlive 为true 且组件名在 cachedViews 中的路由组件 -->
    <keep-alive :include="cachedViews">
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- 非缓存区：直接渲染 keepAlive 为false 的路由组件 -->
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
// 导入API请求方法（根据你的实际路径调整）
import { requestJson, article } from "@/api";

// 定义需要缓存的组件名称列表（对应组件的name选项）
const cachedViews = ref([
  "SchoolLntro", // 学院概况组件名
  "PartyBuild", // 党的建设组件名
  "Treeman", // 立德树人组件名（假设组件声明的name是Treeman）
  "TalentTrain", // 人才培养组件名（假设组件声明的name是TalentTrain）
  "Teachers", // 师资队伍组件名（假设组件声明的name是Teachers）
  "Discipline", // 学科与科研组件名（假设组件声明的name是Discipline）
  "Exchange", // 对外交流组件名（假设组件声明的name是Exchange）
  "Recruit", // 招生宣传组件名（假设组件声明的name是Recruit）
  "OldBoy", // 校友之窗组件名（假设组件声明的name是OldBoy）
  "ExperimentalCondition", // 实验条件组件名（假设组件声明的name是ExperimentalCondition）
  "Talents", // 人才招聘组件名（假设组件声明的name是Talents）
  "Journalism", // 新闻详情组件名（假设组件声明的name是Journalism）
  "PersonParticulars", // 人物详情组件名（假设组件声明的name是PersonParticulars）
  "SafetyCampus", // 平安校园组件名（假设组件声明的name是SafetyCampus）
]);

// 组合式API中使用 onMounted 替代选项式的 mounted
onMounted(async () => {
  try {
    const result = await requestJson(article.vWebsiteArticle.listExternal, {});
    console.debug("文章列表数据：", result);
  } catch (error) {
    console.error("请求文章列表失败：", error);
  }
});
</script>

<style lang="scss"></style>
